export default __webpack_public_path__ + "static/media/WhatsApp Image 2024-02-19 at 3.00.07 PM.12fba36a.jpeg";